export default __webpack_public_path__ + "static/media/image-planalto.33bcba48.png";